<template>
  <div class="products">
    <div class="container">
      <h2 class="products__title">产品中心</h2>

      <!-- 分类筛选功能 -->
      <div class="products__filter" v-if="categories.length > 0">
        <div class="products__filter-buttons">
          <button
            v-for="category in categories"
            :key="category.id"
            class="products__filter-btn"
            :class="{ active: selectedCategoryId === category.id }"
            @click="switchCategory(category)"
          >
            {{ category.name }}
          </button>
        </div>
      </div>

      <!-- 产品列表 -->
      <div class="products__list" v-if="!loading">
        <ProductCard
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="products__loading">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 无数据状态 -->
      <div v-else-if="products.length === 0" class="products__empty">
        <p>暂无产品数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from './ProductCard.vue'
import { productsApi } from '@/api/modules/products'

export default {
  name: 'Products',
  components: {
    ProductCard
  },
  data() {
    return {
      products: [],
      categories: [],
      selectedCategoryId: null,
      loading: false
    }
  },
  computed: {
    currentCategoryName() {
      const category = this.categories.find(cat => cat.id === this.selectedCategoryId)
      return category ? category.name : ''
    }
  },
  mounted() {
    this.getProductCategories()
  },
  methods: {
    // 获取产品分类列表
    async getProductCategories() {
      this.loading = true
      try {
        const response = await productsApi.getCategories()
        if (response.code === 200) {
          this.categories = response.data
          if (this.categories.length > 0) {
            this.selectedCategoryId = this.categories[0].id
            await this.getProductsByCatId(this.selectedCategoryId)
          }
        }
      } catch (error) {
        console.error('获取产品分类失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 切换分类
    async switchCategory(category) {
      if (!category || category.id === this.selectedCategoryId) {
        return
      }
      this.selectedCategoryId = category.id
      await this.getProductsByCatId(category.id)
    },

    // 根据分类ID获取产品列表
    async getProductsByCatId(catId) {
      if (!catId) {
        this.products = []
        return
      }
      this.loading = true
      try {
        const response = await productsApi.getProductsByCategory(catId)
        if (response.code === 200) {
          this.products = response.data
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.products {
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.products__title {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
}

.products__filter {
  margin-bottom: 30px;
}

.products__filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
}

.products__filter-btn {
  padding: 10px 20px;
  border: 1px solid #e9ecef;
  background: #fff;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #666;
}

.products__filter-btn:hover {
  border-color: #007bff;
  color: #007bff;
}

.products__filter-btn.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}

.products__list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
}

.products__loading {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e9ecef;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.products__empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.products__empty p {
  font-size: 16px;
}

@media (max-width: 768px) {
  .products__title {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .products__filter-buttons {
    gap: 8px;
  }

  .products__filter-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .products__list {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
